const article = {
    id: 'process-reports',
    title: 'Process reports',
    summary: 'Pick a client, filter the process flow, and open the SKUs behind any count, including deliveries in the selected period.',
    publishedAt: '2026-09-19',
    tags: ['reports', 'delivery'],
    sections: [
        {
            type: 'paragraph',
            text: 'Reports shows a client’s studio process: where work is sitting, what moved in the dates you pick, and which SKUs were delivered in that period. Click a count to list the SKUs.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it for a client review, to check delivery in a date range, or to see which SKUs sit in a stage.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Reports and select a client.',
                'Use Configure Report if the stages or layout need to change for that client.',
                'Set the date filters and apply them. Delivery counts use the selected range.',
                'Click a process node or a delivery tile to open the SKU list.',
                'Add a filter for csv data, order name, model, or shoot types when you need a narrower list.',
            ],
        },
        {
            type: 'note',
            text: 'Delivery numbers are for the selected period. Stage totals still describe where work is now.',
        },
    ],
};

export default article;
